import { useContext, useLayoutEffect } from 'react'

import { Context } from './context'

export const useWideMainLayout = (value = true) => {
  const { setIsWide } = useContext(Context)
  useLayoutEffect(() => {
    setIsWide(value)

    return () => {
      setIsWide(false)
    }
  })
}

export const useIsWideMainLayout = () => {
  const { isWide } = useContext(Context)
  return [isWide]
}

export const useZeroPaddingMainLayout = (value = true) => {
  const { setZeroPadding } = useContext(Context)
  useLayoutEffect(() => {
    setZeroPadding(value)

    return () => {
      setZeroPadding(false)
    }
  })
}

export const useIsZeroPaddingMainLayout = () => {
  const { zeroPadding } = useContext(Context)
  return [zeroPadding]
}
